// extracted by mini-css-extract-plugin
module.exports = {"homeLink":"Home_homeLink__z0fcd","homeVideo":"Home_homeVideo__bzkzo","videoBox":"Home_videoBox__29K1e","profileImage":"Home_profileImage__f5OX5","overlay":"Home_overlay__SVmhl"};